export default class questionPie {

    constructor( chartId ) {
      this.chartId = chartId;

        this.config = {
            animate : true,
            animationDuration : 1500 , 
            svg: { bg: 'white', h: null, w: null  },
            plotArea : { bg: 'white' },
			margin :  40, 
			colors: { "10": 'green' , "5": 'yellow' , "0" : 'red' }
        };

        this.data = {
            data : []
		};
		
		this.color = d3.scaleOrdinal()
			.domain(["10" , "5" , "0" ])
			.range( [ "green" , "yellow" , "red" ] );

        //this.createElements();
      console.log( 'construct question pie')
    }

    /**
     * render()
     * Renders all svg elements
     * No sizes or positions are specified
     * that is controlled in draw and scale functions
     */
    render(){
        let self = this;
        //get the svg
		let div = d3.select( this.chartId );
		let svg = div.append("svg").style( 'background', self.config.svg.bg );

		
		//set svg size
		svg.attr( 'width' ,  '100%' ); //ful width of parent
		self.config.svg.w = svg.style('width').replace("px", ""); //store width
		self.config.svg.h = self.config.svg.w; //set same height so square
		svg.attr( 'height' , self.config.svg.h ); //set to full height too

		self.radius = Math.min(self.config.svg.w, self.config.svg.h) / 2 - self.config.margin ; //calc radius
		
		let g = svg.append("g")
			.attr("transform", "translate(" + self.config.svg.w / 2 + "," + self.config.svg.h / 2 + ")");

		
		self.pie = d3.pie()
  			.value(function(d) {return d.value; })
		self.data_ready = self.pie(  self.data )
		//self.scalePlot();
		
		self.arc = d3.arc()
						.innerRadius( self.radius * 0.5)         // This is the size of the donut hole
						.outerRadius( self.radius * 0.8);

		// Another arc that won't be drawn. Just for labels positioning
		self.outerArc = d3.arc()
			.innerRadius( self.radius * 0.85)
			.outerRadius( self.radius * 0.85)

		// Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
		g
			.selectAll('allSlices')
			.data( self.data_ready )
			.enter()
			.append('path')
			.attr('d', self.arc )
			.attr( 'class' , function(d){ return 'segment_' + d.data.key } )
			.attr("stroke", "white")
			.style("stroke-width", "2px")
			.style("opacity", 0.95)


		// Add the polylines between chart and labels:
		g
		.selectAll('allPolylines')
		.data( self.data_ready )
		.enter()
		.append('polyline')
		.attr("stroke", "#808080")
		.attr( 'class' , function(d){ return 'segment_polyline segment_polyline_' + d.data.key } )
		.style("fill", "none")
		.attr("stroke-width", 1)
		.attr('points', function(d , i ) {
			var posA = self.arc.centroid(d) // line insertion in the slice
			var posB = self.outerArc.centroid(d) // line break: we use the other arc generator that has been built only for that
			var posC = self.outerArc.centroid(d); // Label position = almost the same as posB
			var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2 // we need the angle to see if the X position will be at the extreme right or extreme left
			posC[0] = self.radius * 0.95 * ( midangle < Math.PI  ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
			return [posA, posB, posC]
		});

		// Add the polylines between chart and labels:
		var labels = g
			.selectAll('allLabels')
			.data( self.data_ready )
			.enter()
			.append('text')
			.attr( 'class' , function(d){ return 'segment_text_' + d.data.key } )

			.text( function(d) { console.log(d.data) ; return d.data.label } )
			.attr('transform', function(d) {
				var textOffset =  [ -2 , 13 ]; //if top half sit on top of line, btm half then drop
				var pos = self.outerArc.centroid(d);
				var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
				pos[0] = self.radius * 0.99 * (midangle < Math.PI ? 1 : -1);
				pos[1] +=  ( pos[1] < 0  ? textOffset[0] : textOffset[1] ) ; //if pos 1 is in 
				//lower hald take off offset
				return 'translate(' + pos + ')';
			})
			.style('text-anchor', function(d) {
				var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
				return (midangle >= Math.PI ? 'start' : 'end')
			});

		var prev;
		var textOffset = 35;
		var currentOffset = textOffset;
		var overlapAllow = 3; //pixels to allow overlapping
		labels.each(function(d, i) {
			
			  if(i > 0) {
				var bb1 = this.getBoundingClientRect(),
					bb2 = prev.getBoundingClientRect();
				// move if they overlap
				if(
					
					(( bb1.bottom + 0 ) <= bb2.bottom && ( bb1.bottom - 0) >= bb2.top) //and top 1 is between top bottom of 2
					/*!( bb1.right < bb2.left  || 
						bb1.left > bb2.right || 
						bb1.bottom < bb2.top || 
						bb1.top > bb2.bottom)*/
				) 
				{


					var currentTranslate =  self.parse( d3.select(this).attr("transform" ) ) ;
                    console.log("🚀 ~ file: questionPie.js ~ line 139 ~ questionPie ~ labels.each ~ currentTranslate", currentTranslate)
				


					d3.select(this).attr("transform",
						"translate(" + (Number(currentTranslate.translate[0]) + currentOffset) + "," +
						(currentTranslate.translate[1] ) + ")");
					currentOffset += textOffset;
				}
			  }else{
			  	prev = this;
			  }
			});
    }


    scalePlot(  ){
        let self = this;
        
		var div = d3.select( this.chartId );
		var svg = div.select('svg');
		var tooltip = d3.select( '.chart-tooltip');
		//set its default props
		svg.attr( 'width' ,  '100%' ).attr( 'height' ,  '300px' ); //set to full width
		//TODO: do we need to set the heigh too? maybe work on a widescreen ratio? and a minimum pixel too
		//det dimensions to save forever
		self.config.svg.w = svg.style('width').replace("px", "");
		self.config.svg.h = svg.style('height').replace("px", "");

		//get plot H and W to save for later
		self.config.plot.w = self.config.svg.w - self.config.axis.y.w - self.config.padding[1] - self.config.padding[3];
		self.config.plot.h = self.config.svg.h - self.config.axis.x.h - self.config.padding[0] - self.config.padding[2];
		self.config.plot.x = self.config.axis.y.w + self.config.padding[ 3 ];
		self.config.plot.y = self.config.padding[ 0 ];
		self.config.plot.x1 = self.config.plot.x + self.config.plot.w ;
		self.config.plot.y1 = self.config.plot.y + self.config.plot.h;

        console.log("scalePlot -> config", self.config)


		var catCnt = svg.selectAll('.xaxis-label').size();
		var catScale = d3.scaleLinear()
						.domain([ -0.5, catCnt - 0.5 ])
						.range([ self.config.plot.x , self.config.plot.x1   ]);
		var scoreScale = d3.scaleLinear()
						.domain([ self.config.axis.y.min , self.config.axis.y.max ])
						.range([ self.config.plot.y1 , self.config.plot.y   ]);

		var lineFunction = d3.line()
                          .x(function(d , i ) { return catScale( d.x ) ; })
                          .y(function(d) { return scoreScale( d.y ) ; })
						  .curve(d3.curveCardinal);

		svg.select('.rect-plot')
				.attr( 'width' , self.config.plot.w )
				.attr( 'height' , self.config.plot.h  )
				.attr( 'x' , self.config.plot.x )
				.attr( 'y' , self.config.plot.y  );
		
		svg.select('.axis-y-line')
				.attr("x1", self.config.plot.x )     
				.attr("y1", self.config.plot.y )      
				.attr("x2", self.config.plot.x )    
				.attr("y2",  self.config.plot.y1 );    
		
		svg.select('.axis-x-line')
				.attr("x1", self.config.plot.x )     
				.attr("y1", self.config.plot.y1 )      
				.attr("x2", self.config.plot.x1 )    
				.attr("y2",  self.config.plot.y1 ); 

		//move data points
		svg.selectAll('circle.plot-point')
			.on("mouseover", function( event , d ){
				let point = d3.select(this);
				point.transition()
					.duration(250)
					.ease(d3.easeBackOut.overshoot(5))
					.attr("r",  self.config.point.r * 1.5 );

				

				console.log( point.data() );
				console.log( d );

				tooltip.text( parseFloat(d.y).toFixed(1)+'% (n='+d.cnt+')' );

				tooltip.style("visibility", "visible");

				let w =  tooltip.node().getBoundingClientRect().width ;
				let h =  tooltip.node().getBoundingClientRect().height ;
				let margin = 30;


				tooltip.style("top", (point.attr('cy') - h - margin )+"px").style("left",(point.attr( 'cx' ) - w/2  )+"px");
			})
			.on("mouseout", function(){
				tooltip.style("visibility", "hidden");

				d3.select(this).transition()
					.duration(250)
					.attr("r",  self.config.point.r  );
				
			})
			.attr( 'cx' , function( d, i  ){
				return catScale( d.x );
			})
			.attr( 'cy' , function( d, i  ){
				return scoreScale( d.y );
			});

		
		svg.selectAll('text.xaxis-label')
			.attr( 'x' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y' , self.config.plot.y1 + 25 )
			.text( function (d) { 
                console.log("d", d)
				return d; 
			}) 
			.attr("text-anchor", "middle")
			.attr("font-size", self.config.axis.x.cats.label.size )
			.attr("fill", self.config.axis.x.cats.label.color );

		svg.selectAll('.axis-x-tick')
			.attr( 'x1' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y1' , self.config.plot.y1  )
			.attr( 'x2' , function( d, i  ){
				return catScale( i );
			})
			.attr( 'y2' , self.config.plot.y1 + self.config.axis.x.cats.ticks.length   );

		svg.selectAll('.axis-y-tick')
			.attr( 'x1' , self.config.plot.x - self.config.axis.y.cats.ticks.length )
			.attr( 'y1' , function( d ){ return scoreScale( d ) } )
			.attr( 'x2' , self.config.plot.x   )
			.attr( 'y2' , function( d ){ return scoreScale( d ) }  );

		svg.selectAll('text.yaxis-label')
			.attr( 'x' , self.config.plot.x - self.config.axis.y.cats.ticks.length - 5 )
			.attr( 'y' , function( d ){ return scoreScale( d ) } );	

		svg.selectAll('.axis-y-gridline')
			.attr( 'x1' , self.config.plot.x  )
			.attr( 'y1' , function( d ){ return scoreScale( d ) } )
			.attr( 'x2' , self.config.plot.x1   )
			.attr( 'y2' , function( d ){ return scoreScale( d ) }  );

		svg.selectAll('.axis-y-band')
			.attr( 'x' , self.config.plot.x  )
			.attr( 'y' , function( d ){ return scoreScale( d ) } )
			.attr( 'width' , self.config.plot.w   )
			.attr( 'height' , function( d ){ 
				var lowerBand = d - self.config.axis.y.cats.interval;
				if( lowerBand < self.config.axis.y.min ){
					lowerBand = self.config.axis.y.min
				}
				return scoreScale( lowerBand )  - scoreScale( d )    
				
			}  );

		var data = JSON.parse( d3.select('.plot-line').attr('data-data') );
		svg.select('.plot-line').attr("d", lineFunction( data ));

		
    }
    

    redraw(  ){
        let self = this;
		var div = d3.select( this.chartId );
		var svg = div.select('svg');

		//data points
		var pointsGroup = svg.select('.group-data-points').selectAll('.plot-point')
			.data( self.data.data );
		pointsGroup.enter()
			.append('circle')
			.attr('class' , 'plot-point');

		pointsGroup.exit().remove();
		
		//add redraw animations only
		svg.selectAll('.plot-point')
			.attr("r",  0  )
			.transition()
			.delay( function ( d, i ){
				return i / self.data.data.length  * self.config.animationDuration * 0.75 ; //0.75 so comes in when line finishes
			})
			.duration( self.config.animationDuration )
			.attr( 'r', self.config.point.r )
			.style( 'fill' , self.config.point.color );

		var xGroupLabels = svg.select('.axis-x-group-cats').selectAll('.xaxis-label')
			.data( self.data.cats );
		xGroupLabels.enter()
			.append('text')
			.attr('class' , 'xaxis-label');
		xGroupLabels.exit().remove();

		var xGroupTicks = svg.select('.group-axis-x-ticks').selectAll('.axis-x-tick')
			.data( self.data.cats );
		xGroupTicks.enter()
			.append('line')
			.attr('class' , 'axis-x-tick');

		xGroupTicks.exit().remove();
		
		
		svg.select('.plot-line')
			.attr("data-data", JSON.stringify( self.data.data ))
			.attr("stroke-dashoffset", 1)
			.attr("stroke-dasharray", 1)
			.transition()
				.duration( self.config.animationDuration )
				.ease(d3.easeLinear)
				.attr("stroke-dashoffset", 0);

        self.scalePlot(  );
	}

	parse (a)
	{
		var b={};
		for (var i in a = a.match(/(\w+\((\-?\d+\.?\d*e?\-?\d*,?)+\))+/g))
		{
			var c = a[i].match(/[\w\.\-]+/g);
			b[c.shift()] = c;
		}
		return b;
	}


}